import decodeUriComponent from 'decode-uri-component';

class LocationHelper {
  static searchAsObj() {
    return window.location.search
      .substr(1)
      .split('&')
      .reduce((acc, kv) => {
        let keyvalue = kv.split('=').map(decodeUriComponent);
        return Object.assign(acc, { [keyvalue[0]]: keyvalue[1] });
      }, {});
  }

  static objAsSearch(obj) {
    if (obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        return `${acc}${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}&`;
      }, '?');
    }
    return '';
  }

  static statesAsQuery(initial = '?', rootKey, whiteListProperties, state) {
    try {
      return (rootKey || [null]).reduce((query, root) => {
        return this.stateAsQuery(state, root, whiteListProperties, query, initial);
      }, initial || '?');
    } catch (e) {
      return '';
    }
  }

  static stateAsQuery(state, root, whiteListProperties, query, initial) {
    if (!root) {
      return `${Object.keys(state).reduce((acc, key) => {
        if (!whiteListProperties || (whiteListProperties || []).includes(key)) {
          return (query += `${key}=${encodeURIComponent(state?.[key])}&`);
        }
        return query;
      }, initial)}`;
    }
    return `${Object.keys(state[root]).reduce((acc, key) => {
      if (!whiteListProperties || (whiteListProperties || []).includes(key)) {
        return (query += `${key}=${encodeURIComponent(state?.[root]?.[key])}&`);
      }
      return query;
    }, initial)}`;
  }

  /**
   *
   * @param initState
   * @param urlStoreStateKey
   * @param whiteListUrlStorage
   */
  static loadStateFromUrlQuery(initState, stateKey, whiteListUrlStorage) {
    let state = Object.assign({}, initState);
    if (typeof state[stateKey] === 'undefined') {
      state[stateKey] = {};
    }
    let search = LocationHelper.searchAsObj() || {};

    if (search?.ignoreDefaults) {
      Object.keys(initState || {})?.forEach((key) => {
        state[key] = false;
      });
    }

    Object.keys(search).forEach((key) => {
      if (!stateKey && (!whiteListUrlStorage || (whiteListUrlStorage || []).includes(key))) {
        state[key] = search[key] === 'null' || search[key] === 'undefined' ? null : decodeURIComponent(search[key]);
      } else if (
        (!whiteListUrlStorage || (whiteListUrlStorage || []).includes(key)) &&
        typeof state[stateKey][key] !== 'undefined'
      ) {
        state[stateKey][key] =
          search[key] === 'null' || search[key] === 'undefined' ? null : decodeURIComponent(search[key]);
      }
    });
    return state;
  }

  static getUrlForSubdomain(subdomain) {
    let host =
      subdomain === 'api'
        ? window.location.hostname
        : window.location.hostname.replace(/(uw|switch)/, subdomain ?? 'switch');

    return `${LocationHelper.getProtocol()}://${host}${LocationHelper.getDomainPort(subdomain)}`;
  }

  static getSubdomainFromUrl() {
    return window.location.hostname.match(/(uw|switch)/)[1];
  }

  static getCookieHost() {
    return window.location.hostname.replace(/(uw|switch)/, '');
  }

  static getProtocol() {
    return LocationHelper.isLocalStack() ? 'https' : 'https';
  }

  static getDomainPort(domain) {
    let isLocal = this.isLocalStack();
    if (isLocal) {
      return (
        {
          jdcs: ':7331',
          switch: '',
          api: '',
          tools: ':4000',
          uw: '',
        }[domain] ?? ''
      );
    }
    return '';
  }

  static isLocalStack() {
    return window.location.hostname.includes('local');
  }

  static getEnvByDomain() {
    return (window.location.hostname.match(/(switch|uw)(.*)concertfin/)[2] || '').replace(/\./g, '') || 'prod';
  }
}
export default LocationHelper;
